import { ObjectValues } from 'common/tsHelpers';
import { ActiveProfile } from './activeProfile';
import { SimulatedOutageStatus } from './simulateOutage';

export const RSIM_PROFILE_ID_NAMES = {
  ICCID: 'ICCID',
  EID: 'EID',
} as const;

export type RSimIdTypeName = ObjectValues<typeof RSIM_PROFILE_ID_NAMES>;

export const RSIM_ID_TYPE = {
  ICCID: 0,
  EID: 1,
} as const;

export type RSimIdType = ObjectValues<typeof RSIM_ID_TYPE>;

export type RSimsFiltersRequestBody = {
  iccid?: string;
  euicc?: string;
  pageSize?: number;
  pageNumber?: number;
  orderNumber?: string;
  connectionId?: string;
  tags?: string[];
  noPollingFrom?: string;
  accountRef?: (number | null)[];
  productCodes?: (string | null)[];
  eidFrom?: string;
  eidTo?: string;
  order?: string;
  simulatedOutageStatuses?: SimulatedOutageStatus[];
  lastActiveProfile?: ActiveProfile;
  subscriptionStatus?: number[];
  rsimProfileIdsFilter?: {
    type: RSimIdType;
    ids: string[];
  };
  rsimProfileIdsRange?: {
    type: RSimIdType;
    idsFrom: string;
    idsTo: string;
  };
  mnoId?: (number | null)[];
  mnoNames?: (string | null)[];
};

export type RSimProfileId = ObjectValues<typeof RSIM_PROFILE_ID_NAMES>;

export type RSimInventoryFilterBodyIdsProps = keyof Pick<
  RSimsFiltersRequestBody,
  'euicc' | 'iccid'
>;

export type RSimSort = {
  columnName: string;
  sort: 'asc' | 'desc' | null;
};
